import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import DialogHeader from "../components/DialogHeader"

export default function DeleteSavedFilterDialog({
  open,
  onClose,
  savedFilter,
}) {
  const [isDeleting, setIsDeleting] = useState(false)

  const axios = useAuthorizedAxiosClient()

  function handleSoftClose() {
    onClose()
  }

  function handleDeleteButtonClicked() {
    setIsDeleting(true)
    axios
      .delete(`/crm/api/saved-filter/${savedFilter.id}/`)
      .then(() => onClose(true))
      .finally(() => setIsDeleting(false))
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Confirm Delete View" onClose={handleSoftClose} />
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete <strong>{savedFilter?.name}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isDeleting}
          onClick={handleDeleteButtonClicked}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
